export const BIBLE_VERSIONS_FETCH_REQUEST = 'BIBLE_VERSIONS_FETCH_REQUEST';
export const BIBLE_VERSIONS_FETCH_SUCCESS = 'BIBLE_VERSIONS_FETCH_SUCCESS';
export const BIBLE_VERSIONS_FETCH_FAIL = 'BIBLE_VERSIONS_FETCH_FAIL';
